import "../../lib/entities/models.js"

Pixlee.module('Entities', function(Entities, App, Backbone, Marionette, $) {

    var API;
    Entities.Config = Entities.Model.extend({
        mutators: {
            isAdmin: function() {
                return _.isFalsy(this.get('adminSu')) ? false : true;
            }
        }
    });

    API = {
        getConfig: function(options) {
            options = options || {};
            return new Entities.Config({
                distilleryUrl: gon.global.distilleryUrl,
                emailServerUrl: gon.global.emailServerUrl,
                distilleryAnalyticsUrl: gon.global.distilleryAnalyticsUrl,
                distilleryUrlMyAlbums: gon.global.distilleryUrlMyAlbums,
                distilleryUrlCountMyAlbums: gon.global.distilleryUrlCountMyAlbums,
                distilleryUrlAnalyticsAlbums: gon.global.distilleryUrlAnalyticsAlbums,
                distilleryUrlAnalyticsAccounts: gon.global.distilleryUrlAnalyticsAccounts,
                distilleryInboxUrl: gon.global.distilleryInboxUrl,
                distilleryInboxCountUrl: gon.global.distilleryInboxCountUrl,
                pixleePhotosServer: gon.global.pixleePhotosServer,
                photoAssetsUrl: gon.global.photoAssetsUrl,
                distilleryPhotoUrl: gon.global.distilleryPhotoUrl,
                distilleryPhotoCrudUrl: gon.global.distilleryPhotoCrudUrl,
                s3_bucket_url: gon.global.s3BucketUrl,
                environment: gon.global.env,
                adminSu: options.adminSu,
                adminUnsu: options.adminUnsu,
                pixleeAdminPanelUrl: options.pixleeAdminPanelUrl,
                productSimilarityUrl: gon.global.productSimilarityUrl,
                liveDisplayHost: gon.global.liveDisplayHost
            });
        },
        getConfigPhotosApp: function() {
            return new Entities.Config({
                distilleryUrl: gon.global.distilleryUrl,
                distilleryAnalyticsUrl: gon.global.distilleryAnalyticsUrl,
                distilleryQueryUrl: gon.global.distilleryQueryUrl,
                pixlee_backend_server: gon.global.pixleeBackendServer,
                environment: gon.global.env,
                s3_bucket_url: gon.global.s3BucketUrl,
                distilleryPhotoUrl: gon.global.distilleryPhotoUrl
            });
        }
    };
    App.reqres.setHandler('set:config', function(options) {
        return API.getConfig(options);
    });
    App.reqres.setHandler('set:config:photos:app', function() {
        return API.getConfigPhotosApp();
    });
});
